import { EventEmitter } from "@angular/core";
import { AfterViewInit, Component, Inject, ViewChild } from "@angular/core";
import { DialogComponent } from "@syncfusion/ej2-angular-popups";
import { Notification } from "src/app/modules/notification/notification";

@Component({
    selector: "ofi-notification-dialog",
    templateUrl: "./notification-dialog.component.html",
    styleUrls: ["./notification-dialog.component.scss"],
    standalone: false
})
export class NotificationDialogComponent implements AfterViewInit {
  @ViewChild("dialog")
  public dialog: DialogComponent;

  public dismissed = new EventEmitter();

  constructor(@Inject("notificationData") public notification: Notification) {}

  public ngAfterViewInit(): void {
    this.dialog.show();
  }

  public onDismiss(): void {
    this.dismissed.emit();
  }
}
